import { logEvent } from './client';
import { sanitizeParams } from './sanitize';
import type { EventName } from './events';

/**
 * Public entry point for all event tracking.
 *
 * Always goes through `sanitizeParams` so callers don't have to think about
 * LGPD redaction at every call-site.
 */
export const track = (name: EventName | string, params?: Record<string, unknown>): void => {
  void logEvent(name, sanitizeParams(params));
};
